import React from "react";
import { Text } from "@/components/atoms/Text/Text";

interface Props {
  errorMessage: string;
  context: string;
  hint?: string;
  textSize?: "body" | "body-md";
}

export function ErrorMessage({
  errorMessage,
  context,
  hint,
  textSize = "body",
}: Props) {
  return (
    <div data-slot="error-card-message" className="space-y-2" data-sentry-component="ErrorMessage" data-sentry-source-file="ErrorMessage.tsx">
      <Text variant={textSize} data-slot="error-card-context" tone="body" data-sentry-element="Text" data-sentry-source-file="ErrorMessage.tsx">
        We had the following error when retrieving {context ?? "your data"}:
      </Text>
      <div
        data-slot="error-card-detail"
        className="rounded-lg border border-separator bg-surface-muted p-3"
      >
        <Text
          variant={textSize}
          data-slot="error-card-detail-text"
          tone="error-strong"
        data-sentry-element="Text" data-sentry-source-file="ErrorMessage.tsx">
          {errorMessage}
        </Text>
      </div>
      {hint && (
        <div data-slot="error-card-hint" className="!mt-4">
          <Text variant={textSize} data-slot="error-card-hint-text" tone="body">
            {hint}
          </Text>
        </div>
      )}
    </div>
  );
}
